import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseFectch';

export interface TokenUsageFilters {
  startDate?: string;
  endDate?: string;
  agentKey?: string;
  agentType?: string;
  userId?: string;
  toolName?: string;
  page?: number;
}

export const aiApi = createApi({
  reducerPath: 'ai',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    chatUpload: builder.mutation<
      { status: string; documentId: string; fileName: string; embeddingStatus: string },
      { data: FormData }
    >({
      query: ({ data }) => ({
        url: `/chat-upload`,
        method: 'POST',
        body: data,
      }),
    }),
    aiProjectdashboard: builder.mutation({
      query: ({ message, agentId, employeeId, lastMessage, mode, urls }) => ({
        url: `/ai/dashboard/project`,
        method: 'POST',
        body: { message, agentId, employeeId, lastMessage, mode, urls },
      }),
    }),
    aiHRDashbaord: builder.mutation({
      query: ({ message, agentId, employeeId, lastMessage, mode, urls }) => ({
        url: `/ai/dashboard/hr`,
        method: 'POST',
        body: { message, agentId, employeeId, lastMessage, mode, urls },
      }),
    }),
    createCompany: builder.mutation({
      query: (data) => ({
        url: `/company`,
        method: 'POST',
        body: data,
      }),
    }),
    getIntakeForms: builder.query<any, void>({
      query: () => '/integration/intake-forms',
    }),
    getTokenUsage: builder.query<any, TokenUsageFilters | void>({
      query: (filters) => {
        if (!filters || Object.keys(filters).length === 0) {
          return '/token-usage';
        }
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            params.append(key, String(value));
          }
        });
        const queryString = params.toString();
        return queryString ? `/token-usage?${queryString}` : '/token-usage';
      },
    }),
  }),
});

export const {
  useChatUploadMutation,
  useAiProjectdashboardMutation,
  useAiHRDashbaordMutation,
  useCreateCompanyMutation,
  useGetIntakeFormsQuery,
  useLazyGetTokenUsageQuery,
} = aiApi;
